import { jsx as _jsx } from "react/jsx-runtime";
import PageSection from '~components/page-section';
import SocialProofCarousel from './carousel';
const SocialProof = ({ title, intro, items }) => (_jsx(PageSection, { id: "social-proof", headerSpacer: ['x3', null, 'x9'], title: title, intro: intro, children: _jsx(SocialProofCarousel, { title: title, items: items }) }));
export default SocialProof;
